import { Link } from "react-router-dom";
import { Plane } from "lucide-react";
import { NAV, NAV_B2B } from "@/data/nav";
import { SCHEDULE, GRUPO } from "@/data/content";
import { TVNetworks } from "@/components/TVNetworks";
import { MainSponsor } from "@/components/MainSponsor";
import { SocialLinks } from "@/components/SocialLinks";

export const Footer = () => (
  <footer className="bg-ink text-cream px-5 sm:px-8 lg:px-12 pt-20 pb-10">
    <div className="mx-auto max-w-7xl">
      <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr_1.2fr]">
        <div>
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-coral">
              <Plane className="h-4 w-4 text-white" strokeWidth={2.5} />
            </span>
            <span className="font-display text-xl font-extrabold tracking-tight">
              Anto<span className="text-coral">&</span>Bella
            </span>
          </div>
          <p className="mt-5 max-w-xs text-cream/60 leading-relaxed">
            La serie de viajes juvenil y familiar. Dos amigas, doce destinos, una
            temporada para verlo todo con otros ojos.
          </p>
          <div className="mt-6">
            <SocialLinks />
          </div>
        </div>

        <div>
          <p className="mb-4 font-mono text-xs uppercase tracking-widest text-mint">
            Explorar
          </p>
          <ul className="space-y-2.5">
            {NAV.map((i) => (
              <li key={i.to}>
                <Link
                  to={i.to}
                  className="text-cream/60 transition-colors hover:text-cream"
                >
                  {i.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="mb-4 font-mono text-xs uppercase tracking-widest text-sky">
            Comercial
          </p>
          <ul className="space-y-2.5">
            {NAV_B2B.map((i) => (
              <li key={i.to}>
                <Link
                  to={i.to}
                  className="text-cream/60 transition-colors hover:text-cream"
                >
                  {i.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="mb-4 font-mono text-xs uppercase tracking-widest text-gold">
            Dónde ver
          </p>
          <p className="font-display text-2xl font-bold">{SCHEDULE.main}</p>
          <p className="mt-1 text-cream/60">{SCHEDULE.region}</p>
          <p className="mt-1 text-cream/60">{SCHEDULE.replay}</p>
          <p className="mt-3 text-cream/60">+ Redes sociales</p>
        </div>
      </div>

      <div className="mt-14 space-y-8 rounded-[2rem] bg-white/5 p-8">
        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-cream/40">
            Transmitido en TV abierta por
          </p>
          <div className="mt-6">
            <TVNetworks />
          </div>
        </div>
        <div className="border-t border-white/10 pt-8">
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-cream/40">
            Espacios comerciales disponibles
          </p>
          <div className="mt-6 flex flex-wrap items-center gap-6">
            {/* Naming = principal, primero de izquierda a derecha */}
            <MainSponsor variant="naming" theme="dark" />
            <MainSponsor variant="slot" theme="dark" label="SPONSOR MAIN" />
            <MainSponsor variant="slot" theme="dark" label="SPONSOR MAIN 2" />
            <MainSponsor variant="slot" theme="dark" label="SPONSOR MAIN 3" />
            <MainSponsor variant="cobranding" theme="dark" label="CO-BRANDING" />
            <MainSponsor variant="cobranding" theme="dark" label="CO-BRANDING 2" />
            <MainSponsor variant="cobranding" theme="dark" label="CO-BRANDING 3" />
          </div>
        </div>
      </div>

      <div className="mt-14 flex flex-col gap-3 border-t border-white/10 pt-6 sm:flex-row sm:items-center sm:justify-between">
        <p className="font-mono text-xs uppercase tracking-widest text-cream/40">
          © {new Date().getFullYear()} Anto&Bella por el Mundo
        </p>
        <p className="font-mono text-xs uppercase tracking-widest text-cream/40">
          Agencia- MediaVerso Estudios.
        </p>
      </div>

      <div className="mt-6 flex flex-col items-center gap-2">
        <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-cream/40">
          2016-2026
        </span>
        <a
          href={GRUPO.url}
          target="_blank"
          rel="noreferrer"
          data-testid="grupo-hiperconvercloud-link"
          aria-label={GRUPO.name}
          className="inline-flex transition-opacity duration-300 hover:opacity-80"
        >
          <img
            src={GRUPO.logo}
            alt={GRUPO.name}
            className="h-9 w-auto"
            data-testid="grupo-hiperconvercloud-logo"
          />
        </a>
      </div>
    </div>
  </footer>
);
